import { Blockquote as Base } from "@corca/tiptap";

import { LineWrapperView } from "./utils/LineWrapperView";

export const Blockquote = Base.extend({
  addNodeView() {
    return (props) => {
      return new LineWrapperView(props, {
        renderNodeAsChildIn: ["listItem", "callout", "tableCell", "tableHeader"],
      });
    };
  },
});
